import { blockResolver } from '@/core/component-resolver.service';
import { defineAsyncComponent } from 'vue';
import CallToActionTile from '@/shared/content/blocks/CallToActionTile.vue';
import CatalogTile from '@/shared/content/blocks/CatalogTile.vue';
import CollageTile from '@/shared/content/blocks/CollageTile.vue';
import FallbackTile from '@/shared/content/blocks/FallbackTile.vue';
import HighlightTile from '@/shared/content/blocks/HighlightTile.vue';
import ProductCoverMaterialTile from '@/shared/content/blocks/pdp/ProductCoverMaterialTile.vue';
import ProductDesignerTile from '@/shared/content/blocks/pdp/ProductDesignerTile.vue';
import ProductEnvironmentMediaTile from '@/shared/content/blocks/pdp/ProductEnvironmentMediaTile.vue';
import ProductStoryTellingVideoTile from '@/shared/content/blocks/pdp/ProductStoryTellingVideoTile.vue';
import ProductMoreFromSameSeriesTile from '@/shared/content/blocks/pdp/ProductMoreFromSameSeriesTile.vue';
import USPTile from '@/shared/content/blocks/pdp/USPTile.vue';
import USPTileRibbon from '@/shared/content/blocks/USPTileRibbon.vue';
import QuestionsAndAnswersTile from '@/shared/content/blocks/QuestionsAndAnswersTile.vue';
import TextTile from '@/shared/content/blocks/TextTile.vue';
import TileTile from '@/shared/content/blocks/TileTile.vue';
import SpecificationsTile from '@/shared/content/blocks/specifications/SpecificationsTile.vue';
import ProductSeriesTile from '@/shared/content/blocks/ProductSeriesTile.vue';
import ProductAddOnTile from '@/shared/product/add-ons/ProductAddOnTile.vue';
import HeroBannerImageContainingTextTile from '@/shared/content/blocks/hero-banner/content/HeroBannerImageContainingTextTile.vue';
import VendorInfoTile from '@/shared/content/blocks/pdp/VendorInfoTile.vue';
import AltaPayPaymentPlaceHolderTile from '@/shared/content/blocks/payment-options/AltaPayPaymentPlaceHolderTileModel.vue';
import ProductTransparencyTile from '@/shared/content/blocks/pdp/ProductTransparencyTile.vue';
import TrustpilotMicroStarWidgetTile from '@/shared/content/blocks/trustpilot/TrustpilotMicroStarWidgetTile.vue';

blockResolver.register('TextTileModel', TextTile);
blockResolver.register('CollageTileModel', CollageTile);
blockResolver.register('CatalogTileModel', CatalogTile);
blockResolver.register('CallToActionTileModel', CallToActionTile);
blockResolver.register('TileTileModel', TileTile);
blockResolver.register('HighlightTileModel', HighlightTile);
blockResolver.register('QuestionsAndAnswersTileModel', QuestionsAndAnswersTile);
blockResolver.register('ProductUspTileModel', USPTile);
blockResolver.register('UspTileModel', USPTileRibbon);
blockResolver.register('ProductSpecificationTileModel', SpecificationsTile);

blockResolver.register('ProductCoverMaterialTileModel', ProductCoverMaterialTile);
blockResolver.register('ProductDesignerTileModel', ProductDesignerTile);
blockResolver.register('ProductEnvironmentMediaTileModel', ProductEnvironmentMediaTile);
blockResolver.register('ProductStoryTellingVideoTileModel', ProductStoryTellingVideoTile);
blockResolver.register('ProductSeriesTileModel', ProductSeriesTile);
blockResolver.register('ProductMoreFromSameSeriesTileModel', ProductMoreFromSameSeriesTile);
blockResolver.register('ProductAddOnTileModel', ProductAddOnTile);
blockResolver.register('ProductTransparencyTileModel', ProductTransparencyTile);
blockResolver.register('TrustpilotWidgetTileModel', TrustpilotMicroStarWidgetTile);

blockResolver.register('HeroBannerImageContainingTextTileModel', HeroBannerImageContainingTextTile);
blockResolver.register('VendorInfoTileModel', VendorInfoTile);

blockResolver.register('AltaPayPaymentPlaceHolderTileModel', AltaPayPaymentPlaceHolderTile);

// Shared features not often used
const asyncClaimFormTile = defineAsyncComponent(() => import(/* webpackChunkName: 'ClaimFormTile', webpackPrefetch: true */ './ClaimFormTile.vue'));
blockResolver.register('ClaimFormTileModel', asyncClaimFormTile);

const asyncPublicClaimFormTile = defineAsyncComponent(() => import(/* webpackChunkName: 'ClaimFormTile', webpackPrefetch: true */ './PublicClaimFormTile.vue'));
blockResolver.register('PublicClaimFormTileModel', asyncPublicClaimFormTile);

const asyncGiftPackagingTile = defineAsyncComponent(() => import(/* webpackChunkName: 'GiftPackagingTile', webpackPrefetch: true */ './GiftPackagingTile.vue'));
blockResolver.register('GiftPackagingTileModel', asyncGiftPackagingTile);

blockResolver.registerFallback(FallbackTile);
